
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/splash",
      function () {
        return require("private-next-pages/splash/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/splash"])
      });
    }
  